<template>
  <div class="login-wrapper">
    <div class="box">
      <h2>登录平台</h2>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      <form @submit.prevent="handleLogin">
        <div class="input-box">
          <label for="username">用户名:</label>
          <input v-model="loginForm.username" type="text" id="username" required/>
        </div>
        <div class="input-box">
          <label for="password">密码</label>
          <input v-model="loginForm.password" type="password" id="password" required/>
        </div>
        <div class="btn-box">
          <a href="#">忘记密码?</a>
          <div>
            <button type="submit">登录</button>
          </div>
        </div>
      </form>
    </div>
    
      <!-- 备案信息区域 - 同一行显示 -->
    <div id="footer-beian">
      <div class="beian-container">
        <!-- ICP备案 -->
        <div class="beian-item">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            豫ICP备2025145865号-1
          </a>
        </div>
        
        <!-- 分隔线 -->
        <div class="beian-divider">|</div>
        
        <!-- 公安备案 -->
        <div class="beian-item">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41058102000969" rel="noreferrer" target="_blank">
            <img src="@/assets/batb.png" alt="公安备案图标" class="police-icon" @error="handleImageError">
            豫公网安备 41058102000969号
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.login-wrapper {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 450px;
  height: 420px;
  border-top: 1px solid rgba(255,255,255,0.2);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255,255,255,0.2);
  border-right: 1px solid rgba(255,255,255,0.2);
  backdrop-filter: blur(10px);
  background: rgba(50,50,50,0.15);  
} 

/* 备案信息容器 */
#footer-beian {
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1000;
  display: flex;
  justify-content: center;
}

.beian-container {
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 13px;
  gap: 12px;
}

/* 备案项通用样式 */
.beian-item a {
  color: rgba(255, 255, 255, 0.95);
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.beian-item a:hover {
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
}

/* 分隔线样式 */
.beian-divider {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

/* 公安备案图标样式 */
.police-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
}


/* 其他原有样式保持不变 */
.box > h2 {
  color: rgba(255,255,255,1);
  margin-bottom: 1rem;
  font-size: 28px;
  font-weight: bold;
}
.box .input-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  margin-bottom: 20px;
}

.box .input-box > label {
  margin-bottom: 8px;
  color: rgba(255,255,255,0.9);
  font-size: 18px;
}

.box .input-box > input {
  box-sizing: border-box;
  color: rgba(255,255,255,0.9);
  font-size: 18px;
  height: 48px;
  width: 320px;
  background: rgba(255,255,255,0.25);
  border: 1px solid rgba(255,255,255,0.4);
  border-radius: 8px;
  transition: 0.2s;
  outline: none;
  padding: 0 12px;
  letter-spacing: 1px;
}

.box .input-box > input:focus {
  border: 1px solid rgba(255,255,255,0.7);
}

.box .btn-box {
  width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
}

.box .btn-box > a {
  font-size: 16px;
  text-decoration: none;
  color: rgba(255,255,255,0.85);
  transition: 0.2s;
  width: 320px;
  text-align: end;
}

.box .btn-box > a:hover {
  color: rgba(255,255,255,1);
}

.box .btn-box > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  margin-top: 25px;
}

.box .btn-box > div > button {
  width: 140px;
  height: 48px;
  border: 1px solid rgba(197, 81, 58,0.6);
  background: rgba(197, 81, 58,0.4);
  color: rgba(255,255,255,0.9);
  border-radius: 8px;
  transition: 0.2s;
  font-size: 20px;
}

.box .btn-box > div > button:nth-of-type(2) {
  margin-left: 15px;
}

.box .btn-box > div > button:hover {
  border: 1px solid rgba(248, 108, 76,0.7);
  background: rgba(248, 108, 76,0.4);
}
</style>

<script>
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/api/index';

export default {
    name: 'Login',
    setup() {
        const router = useRouter();
        const loginForm = reactive({
            username: '',
            password: ''
        });
        const errorMessage = ref('');
        const isSubmitting = ref(false);

        const handleLogin = async () => {
            errorMessage.value = '';
            isSubmitting.value = true;

            try {
                const response = await api.postLogin(
                    loginForm.username,
                    loginForm.password
                );

                if (response.data.ret === 0) {
                    router.push('/data');
                } else {
                    errorMessage.value = response.data.msg || '登录失败，请检查用户名和密码';
                }
            } catch (error) {
                errorMessage.value = '登录请求失败，请检查网络连接';
                console.error('登录异常:', error);
            } finally {
                isSubmitting.value = false;
            }
        };

        return {
            loginForm,
            errorMessage,
            isSubmitting,
            handleLogin
        };
    }
};
</script>